import * as angular from 'angular';
import * as _ from 'lodash';

import { IDashboardService, IstateDependencyService } from '../../services';
import { ComponentDefinition } from '../../models';
import { guidEmpty, guidGroupValidationPageLink } from '../../common';

interface DashboardMenuItem {
    guid: string;
    name: string;
    icon: string;
}

class DashboardListController implements angular.IComponentController {
    dashboards: DashboardMenuItem[];
    addNone: boolean;

    private _none: DashboardMenuItem;
    private _groupValidationPage: DashboardMenuItem;
    private _dashboardIcon: string;

    static $inject = [
        '$translate',
        '$sce',
        'dashboardService',
        'stateDependencyService'
    ];

    constructor(
        $translate: angular.translate.ITranslateService,
        $sce: angular.ISCEService,
        private _dashboardService: IDashboardService,
        private _stateDependencyService: IstateDependencyService,
    ) {
        const validation = $translate.instant('Group validation page');
        this._none = { guid: guidEmpty, name: 'None', icon: $sce.getTrustedHtml('') };
        this._groupValidationPage = { guid: guidGroupValidationPageLink, name: validation, icon: $sce.getTrustedHtml('&#xf046; ') };
        this._dashboardIcon = $sce.getTrustedHtml('&#xf009; ');
    }

    $onInit() {
        this.hasValidationPage()
            .then(hasValidation => {
                this._dashboardService
                    .getAll()
                    .then(data => {
                        let dashboards = _.sortBy(data, d => d.name).map(d => {
                            return { guid: d.guid, name: d.name, icon: this._dashboardIcon};
                        });
                        if (this.addNone) {
                            let sumup = [this._none];
                            if (hasValidation) {
                                sumup = sumup.concat(this._groupValidationPage);
                            }
                            dashboards = sumup.concat(dashboards);
                        } else if (hasValidation) {
                            dashboards = [this._groupValidationPage].concat(dashboards);
                        }
                        this.dashboards = dashboards;
                    });
            });
    }

    private hasValidationPage(): angular.IPromise<boolean> {
        return this._stateDependencyService
            .getItemsByName('dataEntry', 'validation')
            .then(data => !!(data.items && data.items.length))
            .catch(() => false);
    }
}

export const wtDashboardList: ComponentDefinition = {
    componentId: 'wtDashboardList',
    controller: DashboardListController,
    template: require('./dashboardList.component.html'),
    controllerAs: 'vm',
    bindings: {
        addNone: '<',
        isDisabled: '<',
        model: '=',
    }
};